import { Component } from 'preact';
import { HTMLAttributes, InputHTMLAttributes } from 'preact/compat';
import { Maybe } from '../../common/data.js';
import { maybe } from '../../common/util.js';

export interface InputProps extends Omit<Partial<InputHTMLAttributes<HTMLInputElement>>, 'value'> {
	value: Maybe<string | number>;
	attributes?: Record<string, any>;
	handler: (value: string) => void;
	textarea?: boolean;
	class?: string;
}
export class Input extends Component<InputProps> {

	render({ attributes, value, handler, textarea, class: classProp, ...etc }: InputProps) {
		return textarea ? <textarea
			onInput={e => {
				handler((e.target as HTMLTextAreaElement).value);
				this.updateLineCount();
			}}
			onBlur={e => this.setState({})}
			class={classProp}
			value={maybe(value, String) ?? undefined}
			{...etc as Partial<HTMLAttributes<HTMLTextAreaElement>>}
			style={{ '--line-count': this.lineCount }}
			{...attributes}
		/> : <input
			type="text"
			value={maybe(value, String) ?? undefined}
			onInput={e => handler((e.target as HTMLInputElement).value)}
			onBlur={e => this.setState({})}
			class={classProp}
			{...etc as Partial<HTMLAttributes<HTMLInputElement>>}
			{...attributes}
		/>;
	}
	
	componentDidMount() {
		const value = (this.base as HTMLInputElement).value.trim();
		if (value.length && value != String(this.props.value ?? '').trim()) {
			this.props.handler(value);
		}
		else {
			this.updateLineCount();
		}
	}

	lineCount: Maybe<number>;
	updateLineCount(props = this.props) {
		const base = this.base as Maybe<HTMLInputElement>;
		const prev = this.lineCount;
		const cur = this.lineCount = Math.max(
			maybe(props.value, v => String(v).match(/\n/g)?.length) || 0,
			base?.value.match(/\n/g)?.length || 0
		) + 1;
		if (prev != cur && base) base.style.setProperty('--line-count', String(cur));
	}
	
	componentDidUpdate() {
		this.updateLineCount();
	}
	
	shouldComponentUpdate() {
		return this.base != document.activeElement;
	}

}
